import { createFileRoute } from "@tanstack/react-router"
import { ApplyLoginLink } from "@/app"

export const Route = createFileRoute("/$locale/auth/link")({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useSearch()

  return <ApplyLoginLink params={params} />
}
